import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm, SubmitHandler } from "react-hook-form";
import { Button } from "react-aria-components";
// import { ButtonLoader } from "../common/Loader";
import { z } from "zod";
import InputField from "../../widgets/InputField";
import { ButtonLoader } from "../../common/Loader";

interface SignInFormValues {
  email: string;
  password: string;
}

interface SignInFormProps {
  onSubmit: (data: SignInFormValues) => void;
  isError: boolean;
  isPending: boolean;
  message: string;
  visible: { password: boolean };
  handleShowPassword: () => void;
  SignInFormSchema: z.ZodType<SignInFormValues>;
  label: string;
}

const INITIAL_VALUES: SignInFormValues = {
  email: "",
  password: "",
};

const SignInForm: React.FC<SignInFormProps> = ({
  onSubmit,
  isPending,
  message,
  visible,
  handleShowPassword,
  SignInFormSchema,
}) => {
  // const apiUrl = process.env.REACT_APP_API_URL;
  const methods = useForm<SignInFormValues>({
    defaultValues: INITIAL_VALUES,
    resolver: zodResolver(SignInFormSchema),
  });

  const handleSubmit: SubmitHandler<SignInFormValues> = (data: any) => {
    onSubmit(data);
  };

  // const handleLogin = (logintype: string) => {
  //   sessionStorage.removeItem("chats");
  //   axios.get(`${apiUrl}/${logintype}`).then((response: any) => {
  //     window.location.href = response.data.authorization_url;
  //   });
  // };

  return (
    <div className="box bg-transparent md:bg-white p-6 py-12 md:p-12 w-[90vw] md:w-[976px] flex gap-12 md:justify-between">
      <div className="hidden md:block inner-box"></div>
      <div className="w-full md:w-auto">
        <div className="md:w-[420px] h-fit flex flex-col justify-center items-center md:items-start">
          <img
            src="/icons/Logo.svg"
            className="w-[36px] md:w-[54px]"
            alt="logo"
          />
          <h1 className="text-[24px] md:text-[32px] leading-[37.5px] font-medium md:font-light text-[#4E4E4E] md:text-[#1E1E1E] mt-8 md:mt-4">
            Welcome
          </h1>
          <h3 className=" font-light text-[16px] leading-[18.75px] mb-5 hidden md:block">
            Sign in to your account
          </h3>

          <FormProvider {...methods}>
            <form
              onSubmit={methods.handleSubmit(handleSubmit)}
              className=" flex flex-col gap-2 w-full"
            >
              <InputField
                type="email"
                name="email"
                placeHolder="Enter your email"
                fieldId="email-tip"
                message={message}
                label="email"
              />

              <InputField
                type={visible.password ? "text" : "password"}
                name="password"
                placeHolder="Enter your password"
                showIcon={visible.password}
                visible={true}
                handleChange={handleShowPassword}
                label="password"
              />

              <div className="text-gray-400 text-[12px] md:text-[16px] font-normal text-start md:text-end">
                <a href="/forgot-password" className=" text-[#B32C90] mx-1">
                  Forgot Password?
                </a>
              </div>
              <Button
                isDisabled={isPending}
                className={`${
                  isPending ? "sign-load" : "sign"
                } text-[14px] md:text-[16px] p-2 md:p-3 md:h-[48px] focus:outline-none rounded-[8px] md:rounded-normal font-normal w-full text-white tracking-widest`}
                type="submit"
              >
                {isPending ? <ButtonLoader /> : "Sign In"}
              </Button>
              {/* <div className=" text-center block md:hidden text-[#64645F] text-[12px] md:text-[16px] font-normal">
                Don't have an account?
                <a href="/register" className=" text-[#B32C90] mx-1">
                  Sign Up
                </a>
              </div>
              <div className="  flex gap-0 md:gap-2 items-center py-2">
                <span className=" w-full border-b-2 border-gray-200"></span>
                <span className=" text-[12px] font-light text-[#8C939F] hidden md:block">
                  OR
                </span>
                <span className=" w-full border-b-2 border-gray-200"></span>
              </div> */}
              {/* <div
                onClick={() => handleLogin("google-login")}
                className="form-input border rounded-[8px] md:rounded-normal flex items-center justify-center gap-2 hover:border-2 hover:border-[#E78E24] cursor-pointer"
              >
                <img
                  src="/assets/Google.svg"
                  alt="google"
                  className="w-[16px] md:w-[24px]"
                />
                <span className=" text-[14px] md:text-[16px] font-normal leading-[24px] text-[#25282E]">
                  Continue with Google
                </span>
              </div>
              <div
                onClick={() => handleLogin("ms-login")}
                className="form-input border rounded-[8px] md:rounded-normal flex items-center justify-center gap-2 hover:border-2 hover:border-[#E78E24] cursor-pointer"
              >
                <img
                  src="/assets/microsoft.svg"
                  alt="microsoft"
                  className="w-[16px] md:w-[24px]"
                />
                <span className=" text-[14px] md:text-[16px] font-normal leading-[24px] text-[#25282E]">
                  Continue with Microsoft
                </span>
              </div>
              <div className="hidden md:block text-[#64645F] text-[16px] font-light">
                Don't have an account?
                <a href="/register" className=" text-[#B32C90] mx-1">
                  Sign Up
                </a>
              </div> */}
            </form>
          </FormProvider>
          {/* <div className=" text-gray-400 h-fit mt-10 text-[12px] leading-[18px] font-light hidden md:block">
            <div>
              All Rights Reserved. By registering or logging in, you agree to
              our,{" "}
            </div>
            <a
              href="/terms-service"
              target="_blank"
              className=" text-[#B32C90] mx-1"
            >
              Terms and Conditions
            </a>
            ,
            <a
              href="/usage-policy"
              target="_blank"
              className=" text-[#B32C90] mx-1"
            >
              {" "}
              Usage Policy
            </a>{" "}
            and
            <a
              href="/privacy-policy"
              target="_blank"
              className=" text-[#B32C90] mx-1"
            >
              Privacy Policy
            </a>
          </div> */}
          <div className=" text-gray-400 h-fit mt-32 text-[12px] leading-[18px] font-normal md:hidden flex w-full justify-between items-center">
            <a
              href="/terms-service"
              target="_blank"
              className=" text-[#B32C90] mx-1"
            >
              Terms and Conditions
            </a>
            <div className="border-r-[1px] border-border h-[14px]"></div>
            <a
              href="/usage-policy"
              target="_blank"
              className=" text-[#B32C90] mx-1"
            >
              Usage Policy
            </a>
            <div className="border-r-[1px] border-border h-[14px]"></div>
            <a
              href="/privacy-policy"
              target="_blank"
              className=" text-[#B32C90] mx-1"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignInForm;
